import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/marketing/lead-magnet")({
  beforeLoad: requirePermissionGuard("hca.lead_magnet.read"),
});
